import confetti from 'canvas-confetti';

// Krátka oslava — dve strany + stredný výbuch (štýl Linear/Vercel "all done").
export const fireConfetti = () => {
    const defaults = { ticks: 220, gravity: 0.9, scalar: 1, zIndex: 2000 };

    confetti({
        ...defaults,
        particleCount: 90,
        spread: 75,
        origin: { x: 0.5, y: 0.6 },
    });

    setTimeout(() => {
        confetti({ ...defaults, particleCount: 45, angle: 60, spread: 60, origin: { x: 0, y: 0.7 } });
        confetti({ ...defaults, particleCount: 45, angle: 120, spread: 60, origin: { x: 1, y: 0.7 } });
    }, 250);
};
